import React from 'react';
import {
  PreviewContainer,
  PreviewHeader,
  PreviewTitle,
  PreviewContent,
  PreviewFrame,
  EmptyState,
  LoadingState,
} from './styles';

const HtmlPreview = ({ htmlContent, isLoading, currentPrintTypeLabel }) => {
  const renderContent = () => {
    if (isLoading) {
      return (
        <LoadingState>
          <div className="spinner" />
          <span>Carregando conteúdo...</span>
        </LoadingState>
      );
    }
    if (!htmlContent) {
      return (
        <EmptyState>
          <span>Nenhum conteúdo para exibir</span>
          <small>
            Selecione um tipo de impressão e digite um ID para buscar o conteúdo
            HTML
          </small>
        </EmptyState>
      );
    }
    return (
      <PreviewFrame
        sandbox="allow-scripts"
        srcDoc={htmlContent}
        title="HTML Preview"
        // sandbox="allow-same-origin"
      />
    );
  };
  return (
    <PreviewContainer>
      <PreviewHeader>
        <PreviewTitle>
          {currentPrintTypeLabel
            ? `Preview - ${currentPrintTypeLabel}`
            : 'Preview do HTML'}
        </PreviewTitle>
      </PreviewHeader>
      <PreviewContent>{renderContent()}</PreviewContent>
    </PreviewContainer>
  );
};

export default HtmlPreview;
